import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import "./Transcation.scss";
import { ArrowLeft } from "lucide-react";
import axios from "axios";
import { url_261 } from "../../../custom_utilities/api_services";
import { useHistory } from "react-router-dom";
import DateRangePicker from "./ReferAndEarnModals/DateRangePicker";
import Header_component from "../structure_components/desktop_screens/header_component/header_component";
import uiActions from "../../../redux/ui/action";

const Transaction = ({ token, tokenType, startLoading, finishLoading, hideHeader }) => {
  const [state, setState] = useState({
    TranscationData: [],
  });
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const history = useHistory();

  useEffect(() => {
    streaksApi();
  }, []);

  const streaksApi = async (fromDate, toDate) => {
    try {
      const startDateToUse = fromDate || startDate;
      const endDateToUse = toDate || endDate;

      const headers = {
        Authorization: `${tokenType} ${token}`,
      };

      let apiUrl = url_261;

      if (startDateToUse && endDateToUse) {
        apiUrl += `?from_date=${startDateToUse}&to_date=${endDateToUse}`;
      }

      const response = await axios.get(apiUrl, { headers });

      if (response.data.status === 200) {
        if (
          response.data.fromDate &&
          response.data.toDate &&
          !fromDate &&
          !toDate
        ) {
          setStartDate(response.data.fromDate);
          setEndDate(response.data.toDate);
        }

        setState((prevState) => {
          return {
            ...prevState,
            TranscationData: response.data.data,
          };
        });
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleBackClick = () => {
    history.goBack();
  };

  return (
    <>
      {!hideHeader && <Header_component />}
      <div className="transactions-container">
        <div className="transactions-header">
          <div className="back-button">
            <ArrowLeft size={20} onClick={handleBackClick} />
            <span>Transactions</span>
          </div>
          <DateRangePicker
            setStartDate={setStartDate}
            setEndDate={setEndDate}
            onConfirm={(fromDate, toDate) => {
              streaksApi(fromDate, toDate);
            }}
          />
        </div>

        <div className="transactions-list">
          {isLoading ? (
            [...Array(4)].map((_, i) => (
              <div key={i} className="transactions-skeleton-item" />
            ))
          ) : state.TranscationData.length === 0 ? (
            <div className="no-transactions">
              <span>No transactions found</span>
            </div>
          ) : (
            state.TranscationData.map((transaction, index) => (
              <div key={index} className="transaction-item">
                <div className="transaction-info">
                  <span className="date">{transaction.date}</span>
                  <h3 className="title">{transaction.course_name}</h3>
                  <span className="type">{transaction.pay_type}</span>
                </div>
                <div className="transaction-status">
                  <span
                    className={`status ${transaction.status.toLowerCase()}`}
                  >
                    {transaction.status}
                  </span>
                  <span
                    className={`amount ${
                      transaction.isPositive ? "positive" : "negative"
                    }`}
                    style={{ color: transaction.color }}
                  >
                    {transaction.isPositive ? "- " : "+ "}₹{transaction.amount}
                  </span>

                  {transaction.is_cancelable === 1 ? (
                    <button className="action-button">
                      Cancel/Modify Request
                    </button>
                  ) : (
                    transaction.comments && (
                      <span className="error-message">
                        {transaction.comments}
                      </span>
                    )
                  )}
                </div>
              </div>
            ))
          )}
        </div>
      </div>
    </>
  );
};

const mapStateToProps = (state) => {
  console.log("redux", state);
  return {
    token: state.auth.authToken,
    tokenType: state.auth.tokenType,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    startLoading: () => {
      dispatch(uiActions.startLoading());
    },
    finishLoading: () => {
      dispatch(uiActions.finishLoading());
    },
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(Transaction);
